import { useState, useRef, useEffect } from "react";
import { X } from "lucide-react";
import { Input } from "./ui/input";

// "Assegnato a / Cerca persona…" — picks a Persona from the anagrafica (robust id) OR keeps a
// free-text name (display fallback for people not yet in the directory). NO AUTOFOCUS.
// value = { personId, name }. onChange({ personId, name }).
//  - typing => free text (personId cleared)
//  - clicking a suggestion => that person's id + name
//  - "Io" shortcut appears when the current user is linked to a Persona (me prop).
export function PersonPicker({ people = [], value = { personId: "", name: "" }, onChange, me, testId, placeholder = "Cerca persona…", disabled }) {
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);
  const name = value?.name || "";

  useEffect(() => {
    const h = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const q = name.trim().toLowerCase();
  const matches = people.filter((p) => !p.archived && (!q || (p.name || "").toLowerCase().includes(q)));
  const showMe = me && me.personId && (!q || (me.name || "").toLowerCase().includes(q));

  return (
    <div className="relative" ref={boxRef}>
      <div className="relative flex items-center">
        <Input data-testid={testId} value={name} placeholder={placeholder} autoComplete="off" disabled={disabled}
          className={value?.personId || name ? "pr-8" : ""}
          onChange={(e) => { onChange({ personId: "", name: e.target.value }); setOpen(true); }}
          onFocus={() => setOpen(true)} />
        {(value?.personId || name) && (
          <button type="button" data-testid={testId ? `${testId}-clear` : undefined}
            onMouseDown={(e) => { e.preventDefault(); onChange({ personId: "", name: "" }); }}
            className="absolute right-2 text-[#8C7A5E] p-1"><X className="h-3.5 w-3.5" /></button>
        )}
      </div>
      {value?.personId && <p className="text-[10px] text-[#2E7D5B] mt-0.5">Persona collegata</p>}
      {open && !disabled && (matches.length > 0 || showMe) && (
        <div data-testid={testId ? `${testId}-list` : undefined}
          className="absolute z-50 mt-1 w-full max-h-56 overflow-auto rounded-lg border border-[#E5DEC9] bg-white shadow-lg">
          {showMe && (
            <button type="button" data-testid={testId ? `${testId}-me` : undefined}
              onMouseDown={(e) => { e.preventDefault(); onChange({ personId: me.personId, name: me.name }); setOpen(false); }}
              className="w-full text-left px-3 py-2 text-sm hover:bg-[#F0EAE1] text-[#1B3B2B] font-medium">Io — {me.name}</button>
          )}
          {matches.slice(0, 40).map((p) => (
            <button key={p.id} type="button" data-testid={testId ? `${testId}-opt-${p.id}` : undefined}
              onMouseDown={(e) => { e.preventDefault(); onChange({ personId: p.id, name: p.name }); setOpen(false); }}
              className="w-full text-left px-3 py-2 text-sm hover:bg-[#F0EAE1] text-[#1B3B2B]">
              {p.name}{p.user_id ? <span className="text-[10px] text-[#2E7D5B]"> · account</span> : ""}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
